/* Auto-generated translations — re-run scripts/translate_i18n.py to refresh.
   IT and EN are hand-edited; FR/DE/ES are produced by Claude Sonnet 4.5. */
const translations = {
  it: {
  "nav": {
    "prezzi": "Prezzi",
    "moduli": "Moduli",
    "onboarding": "Onboarding",
    "integrazioni": "Integrazioni",
    "supporto": "Supporto",
    "blog": "Blog",
    "cta": "Prova Bonsai",
    "moduliAll": "Vedi tutti i moduli",
    "moduliAllDesc": "Panoramica e confronto dei moduli BSpanel"
  },
  "hero": {
    "badge": "Gestione marketplace unificata",
    "title": "Un sistema integrato per tutti i canali di vendita.",
    "subtitle": "Centralizza tutte le attività operative per far aumentare le vendite online.",
    "cta": "Prova demo",
    "feat1": "Onboarding assistito in 24h",
    "feat2": "Supporto 7/7 h24",
    "topline": "",
    "dashboardOverlay": "Richiedi una demo"
  },
  "proof": {
    "badge": "Risultati",
    "title": "Primi 3 mesi",
    "stat1": "Ordini/giorno",
    "stat2": "Errori picking",
    "stat3": "Errori scheda prodotto",
    "quote": "\"Ordini Amazon e Temu unificati. +25% in 3 mesi.\"",
    "author": "Alberto, COO Baroni Home",
    "scaleTitle": "Scala senza attriti",
    "scaleItems": [
      "+100k varianti",
      "5k spedizioni/giorno",
      "Assistenza con risposta entro 10 minuti",
      "Modulare e scalabile. Il sistema cresce con le tue vendite"
    ]
  },
  "clients": {
    "title": "Hanno scelto Bonsai"
  },
  "whybonsai": {
    "badge": "Ecco perché",
    "title": "Bonsai",
    "subtitle": "Gestisci, automatizza e analizza tutti i canali da un unico punto.",
    "features": {
      "automation": "Automazione Ordini",
      "marketplace": "Marketplace",
      "analytics": "Analytics",
      "warehouse": "Magazzino",
      "integration": "Integrazioni",
      "operations": "Operatività",
      "shipping": "Spedizioni"
    },
    "outputs": {
      "multichannel": "Multicanale"
    },
    "labels": {
      "csvExcel": "CSV/EXCEL",
      "apiCustom": "API CUSTOM",
      "wms": "WMS",
      "altri": "ALTRI SISTEMI"
    }
  },
  "modules": {
    "badge": "Moduli",
    "title": "Scegli cosa ti serve",
    "subtitle": "Ogni modulo è indipendente. Scala quando vuoi.",
    "channelsLabel": "Canali / Integrazioni",
    "featuresLabel": "Funzionalità principali"
  },
  "comparison": {
    "badge": "Confronto",
    "title": "Tutto in uno. Gli altri no.",
    "subtitle": "",
    "feature": "Funzionalità",
    "competitor": "Competitor"
  },
  "press": {
    "badge": "Parlano di noi"
  },
  "faq": {
    "badge": "FAQ",
    "title": "Domande frequenti",
    "subtitle": "",
    "discoverAll": "Scopri tutte le FAQ"
  },
  "whyModular": {
    "alwaysIncluded": "SEMPRE INCLUSO"
  },
  "risorse": {
    "label": "Risorse",
    "sezioni": {
      "scopri": "Scopri",
      "partner": "Partner",
      "clienti": "Clienti",
      "news": "News"
    },
    "items": {
      "blog": {
        "label": "Blog",
        "desc": "Approfondimenti e aggiornamenti."
      },
      "docs": {
        "label": "Documentazione e Integrazioni",
        "desc": "Documentazione tecnica e guide API."
      },
      "helpCenter": {
        "label": "Help Center",
        "desc": "Supporto e documentazione."
      },
      "diventaPartner": {
        "label": "Diventa partner",
        "desc": "Entra nella nostra rete di partner."
      },
      "casiUso": {
        "label": "Casi d'uso",
        "desc": "Leggi le storie di successo dei nostri clienti."
      },
      "ultimeNotizie": {
        "label": "Ultime notizie",
        "desc": "Resta aggiornato - iscriviti alla newsletter."
      }
    }
  },
  "footer": {
    "contact": "Contatti",
    "follow": "Follow",
    "pages": "Pagine",
    "blog": "BLOG Of Bonsai",
    "discover": "Scopri",
    "terms": "Termini e condizioni",
    "privacy": "Privacy Policy",
    "cta": "Prenota una call",
    "compliance": "Compliance:",
    "complianceLine1": "Bonsai opera nel rispetto delle Amazon SP-API Policies. L'accesso e l'uso dei dati è regolamentato e limitato alle finalità autorizzate.",
    "complianceLine2": "Bonsai non memorizza, elabora o trasmette dati di Amazon al di fuori delle connessioni ufficiali SP-API.",
    "copyright": "© {year} Bonsai. Tutti i diritti riservati.",
    "sedeLegale": "Sede Legale:",
    "sedeOperativa": "Sede Operativa:"
  },
  "common": {
    "home": "Home",
    "contatti": "Contatti",
    "send": "Invia",
    "email": "Email",
    "name": "Nome",
    "surname": "Cognome",
    "phone": "Telefono",
    "notes": "Note"
  },
  "a11y": {
    "skipToContent": "Vai al contenuto principale",
    "loading": "Caricamento..."
  }
},
  en: {
  "nav": {
    "prezzi": "Pricing",
    "moduli": "Modules",
    "onboarding": "Onboarding",
    "integrazioni": "Integrations",
    "supporto": "Support",
    "blog": "Blog",
    "cta": "Try Bonsai",
    "moduliAll": "See all modules",
    "moduliAllDesc": "BSpanel modules overview and comparison"
  },
  "hero": {
    "badge": "Unified marketplace management",
    "title": "One integrated system for all sales channels.",
    "subtitle": "Centralize all operational activities to increase online sales.",
    "cta": "Try demo",
    "feat1": "Assisted onboarding in 24h",
    "feat2": "Support 7/7 24h",
    "topline": "",
    "dashboardOverlay": "Request a demo"
  },
  "proof": {
    "badge": "Results",
    "title": "First 3 months",
    "stat1": "Orders/day",
    "stat2": "Picking errors",
    "stat3": "Product listing errors",
    "quote": "\"Amazon and Temu orders unified. +25% in 3 months.\"",
    "author": "Alberto, COO Baroni Home",
    "scaleTitle": "Scale without friction",
    "scaleItems": [
      "+100k variants",
      "5k shipments/day",
      "Support with response within 10 minutes",
      "Modular and scalable. The system grows with your sales"
    ]
  },
  "clients": {
    "title": "They chose Bonsai"
  },
  "whybonsai": {
    "badge": "Here's why",
    "title": "Bonsai",
    "subtitle": "Manage, automate and analyze all channels from one place.",
    "features": {
      "automation": "Order Automation",
      "marketplace": "Marketplace",
      "analytics": "Analytics",
      "warehouse": "Warehouse",
      "integration": "Integrations",
      "operations": "Operations",
      "shipping": "Shipping"
    },
    "outputs": {
      "multichannel": "Multichannel"
    },
    "labels": {
      "csvExcel": "CSV/EXCEL",
      "apiCustom": "CUSTOM API",
      "wms": "WMS",
      "altri": "OTHER SYSTEMS"
    }
  },
  "modules": {
    "badge": "Modules",
    "title": "Choose what you need",
    "subtitle": "Each module is independent. Scale when you want.",
    "channelsLabel": "Channels / Integrations",
    "featuresLabel": "Key features"
  },
  "comparison": {
    "badge": "Comparison",
    "title": "All in one. They're not.",
    "subtitle": "",
    "feature": "Feature",
    "competitor": "Competitor"
  },
  "press": {
    "badge": "In the press"
  },
  "faq": {
    "badge": "FAQ",
    "title": "Frequently asked questions",
    "subtitle": "",
    "discoverAll": "See all FAQs"
  },
  "whyModular": {
    "alwaysIncluded": "ALWAYS INCLUDED"
  },
  "risorse": {
    "label": "Resources",
    "sezioni": {
      "scopri": "Discover",
      "partner": "Partners",
      "clienti": "Customers",
      "news": "News"
    },
    "items": {
      "blog": {
        "label": "Blog",
        "desc": "Insights and updates."
      },
      "docs": {
        "label": "Documentation & Integrations",
        "desc": "Technical docs and API guides."
      },
      "helpCenter": {
        "label": "Help Center",
        "desc": "Support and documentation."
      },
      "diventaPartner": {
        "label": "Become a partner",
        "desc": "Join our partner network."
      },
      "casiUso": {
        "label": "Case studies",
        "desc": "Read our customers’ success stories."
      },
      "ultimeNotizie": {
        "label": "Latest news",
        "desc": "Stay up to date — subscribe to the newsletter."
      }
    }
  },
  "footer": {
    "contact": "Contact",
    "follow": "Follow",
    "pages": "Pages",
    "blog": "BLOG Of Bonsai",
    "discover": "Discover",
    "terms": "Terms and conditions",
    "privacy": "Privacy Policy",
    "cta": "Book a call",
    "compliance": "Compliance:",
    "complianceLine1": "Bonsai operates in compliance with Amazon SP-API Policies. Data access and use are regulated and limited to authorized purposes.",
    "complianceLine2": "Bonsai does not store, process or transmit Amazon data outside the official SP-API connections.",
    "copyright": "© {year} Bonsai. All rights reserved.",
    "sedeLegale": "Legal Office:",
    "sedeOperativa": "Operational Office:"
  },
  "common": {
    "home": "Home",
    "contatti": "Contact",
    "send": "Send",
    "email": "Email",
    "name": "Name",
    "surname": "Surname",
    "phone": "Phone",
    "notes": "Notes"
  },
  "a11y": {
    "skipToContent": "Skip to main content",
    "loading": "Loading..."
  }
},
  fr: {
  "nav": {
    "prezzi": "Tarifs",
    "moduli": "Modules",
    "onboarding": "Onboarding",
    "integrazioni": "Intégrations",
    "supporto": "Support",
    "blog": "Blog",
    "cta": "Essayer Bonsai",
    "moduliAll": "Voir tous les modules",
    "moduliAllDesc": "Aperçu et comparaison des modules BSpanel"
  },
  "hero": {
    "badge": "Gestion marketplace unifiée",
    "title": "Un système intégré pour tous les canaux de vente.",
    "subtitle": "Centralisez toutes les activités opérationnelles pour augmenter les ventes en ligne.",
    "cta": "Essayer la démo",
    "feat1": "Onboarding assisté en 24h",
    "feat2": "Support 7/7 24h",
    "topline": "",
    "dashboardOverlay": "Demander une démo"
  },
  "proof": {
    "badge": "Résultats",
    "title": "3 premiers mois",
    "stat1": "Commandes/jour",
    "stat2": "Erreurs picking",
    "stat3": "Erreurs fiche produit",
    "quote": "\"Commandes Amazon et Temu unifiées. +25% en 3 mois.\"",
    "author": "Alberto, COO Baroni Home",
    "scaleTitle": "Évoluez sans friction",
    "scaleItems": [
      "+100k variantes",
      "5k expéditions/jour",
      "Assistance avec réponse sous 10 minutes",
      "Modulaire et évolutif. Le système grandit avec vos ventes"
    ]
  },
  "clients": {
    "title": "Ils ont choisi Bonsai"
  },
  "whybonsai": {
    "badge": "Voici pourquoi",
    "title": "Bonsai",
    "subtitle": "Gérez, automatisez et analysez tous les canaux depuis un point unique.",
    "features": {
      "automation": "Automatisation Commandes",
      "marketplace": "Marketplace",
      "analytics": "Analytics",
      "warehouse": "Entrepôt",
      "integration": "Intégrations",
      "operations": "Opérations",
      "shipping": "Expéditions"
    },
    "outputs": {
      "multichannel": "Multicanal"
    },
    "labels": {
      "csvExcel": "CSV/EXCEL",
      "apiCustom": "API CUSTOM",
      "wms": "WMS",
      "altri": "AUTRES SYSTÈMES"
    }
  },
  "modules": {
    "badge": "Modules",
    "title": "Choisissez ce dont vous avez besoin",
    "subtitle": "Chaque module est indépendant. Évoluez quand vous voulez.",
    "channelsLabel": "Canaux / Intégrations",
    "featuresLabel": "Fonctionnalités principales"
  },
  "comparison": {
    "badge": "Comparaison",
    "title": "Tout-en-un. Pas les autres.",
    "subtitle": "",
    "feature": "Fonctionnalité",
    "competitor": "Concurrent"
  },
  "press": {
    "badge": "Ils parlent de nous"
  },
  "faq": {
    "badge": "FAQ",
    "title": "Questions fréquentes",
    "subtitle": "",
    "discoverAll": "Découvrir toutes les FAQ"
  },
  "whyModular": {
    "alwaysIncluded": "TOUJOURS INCLUS"
  },
  "risorse": {
    "label": "Ressources",
    "sezioni": {
      "scopri": "Découvrir",
      "partner": "Partenaire",
      "clienti": "Clients",
      "news": "Actualités"
    },
    "items": {
      "blog": {
        "label": "Blog",
        "desc": "Analyses approfondies et mises à jour."
      },
      "docs": {
        "label": "Documentation et Intégrations",
        "desc": "Documentation technique et guides API."
      },
      "helpCenter": {
        "label": "Centre d'aide",
        "desc": "Support et documentation."
      },
      "diventaPartner": {
        "label": "Devenir partenaire",
        "desc": "Rejoignez notre réseau de partenaires."
      },
      "casiUso": {
        "label": "Cas d'usage",
        "desc": "Lisez les success stories de nos clients."
      },
      "ultimeNotizie": {
        "label": "Dernières actualités",
        "desc": "Restez informé - abonnez-vous à la newsletter."
      }
    }
  },
  "footer": {
    "contact": "Contact",
    "follow": "Suivre",
    "pages": "Pages",
    "blog": "BLOG de Bonsai",
    "discover": "Découvrir",
    "terms": "Conditions générales",
    "privacy": "Politique de confidentialité",
    "cta": "Réserver un appel",
    "compliance": "Conformité :",
    "complianceLine1": "Bonsai opère dans le respect des Amazon SP-API Policies. L'accès et l'utilisation des données sont réglementés et limités aux finalités autorisées.",
    "complianceLine2": "Bonsai ne stocke, ne traite ni ne transmet de données Amazon en dehors des connexions officielles SP-API.",
    "copyright": "© {year} Bonsai. Tous droits réservés.",
    "sedeLegale": "Siège social :",
    "sedeOperativa": "Siège opérationnel :"
  },
  "common": {
    "home": "Accueil",
    "contatti": "Contact",
    "send": "Envoyer",
    "email": "E-mail",
    "name": "Prénom",
    "surname": "Nom",
    "phone": "Téléphone",
    "notes": "Notes"
  },
  "a11y": {
    "skipToContent": "Aller au contenu principal",
    "loading": "Chargement..."
  }
},
  de: {
  "nav": {
    "prezzi": "Preise",
    "moduli": "Module",
    "onboarding": "Onboarding",
    "integrazioni": "Integrationen",
    "supporto": "Support",
    "blog": "Blog",
    "cta": "Bonsai testen",
    "moduliAll": "Alle Module anzeigen",
    "moduliAllDesc": "Übersicht und Vergleich der BSpanel-Module"
  },
  "hero": {
    "badge": "Einheitliche Marketplace-Verwaltung",
    "title": "Ein integriertes System für alle Vertriebskanäle.",
    "subtitle": "Zentralisieren Sie alle operativen Aktivitäten, um Online-Verkäufe zu steigern.",
    "cta": "Demo testen",
    "feat1": "Begleitetes Onboarding in 24 Std.",
    "feat2": "Support 7/7 24 Std.",
    "topline": "",
    "dashboardOverlay": "Demo anfordern"
  },
  "proof": {
    "badge": "Ergebnisse",
    "title": "Erste 3 Monate",
    "stat1": "Bestellungen/Tag",
    "stat2": "Kommissionierungsfehler",
    "stat3": "Produktdatenblattfehler",
    "quote": "\"Amazon- und Temu-Bestellungen vereinheitlicht. +25% in 3 Monaten.\"",
    "author": "Alberto, COO Baroni Home",
    "scaleTitle": "Skalieren ohne Reibung",
    "scaleItems": [
      "+100k Varianten",
      "5k Versendungen/Tag",
      "Support mit Antwort innerhalb von 10 Minuten",
      "Modular und skalierbar. Das System wächst mit Ihren Verkäufen"
    ]
  },
  "clients": {
    "title": "Sie haben Bonsai gewählt"
  },
  "whybonsai": {
    "badge": "Deshalb",
    "title": "Bonsai",
    "subtitle": "Verwalten, automatisieren und analysieren Sie alle Kanäle von einem einzigen Punkt aus.",
    "features": {
      "automation": "Auftragsautomatisierung",
      "marketplace": "Marketplace",
      "analytics": "Analytics",
      "warehouse": "Lager",
      "integration": "Integrationen",
      "operations": "Betrieb",
      "shipping": "Versand"
    },
    "outputs": {
      "multichannel": "Multichannel"
    },
    "labels": {
      "csvExcel": "CSV/EXCEL",
      "apiCustom": "API CUSTOM",
      "wms": "WMS",
      "altri": "ANDERE SYSTEME"
    }
  },
  "modules": {
    "badge": "Module",
    "title": "Wählen Sie, was Sie brauchen",
    "subtitle": "Jedes Modul ist unabhängig. Skalieren Sie, wann Sie wollen.",
    "channelsLabel": "Kanäle / Integrationen",
    "featuresLabel": "Hauptfunktionen"
  },
  "comparison": {
    "badge": "Vergleich",
    "title": "Alles in einem. Die anderen nicht.",
    "subtitle": "",
    "feature": "Funktionen",
    "competitor": "Wettbewerber"
  },
  "press": {
    "badge": "Sie sprechen über uns"
  },
  "faq": {
    "badge": "FAQ",
    "title": "Häufig gestellte Fragen",
    "subtitle": "",
    "discoverAll": "Alle FAQs entdecken"
  },
  "whyModular": {
    "alwaysIncluded": "IMMER ENTHALTEN"
  },
  "risorse": {
    "label": "Ressourcen",
    "sezioni": {
      "scopri": "Entdecken",
      "partner": "Partner",
      "clienti": "Kunden",
      "news": "News"
    },
    "items": {
      "blog": {
        "label": "Blog",
        "desc": "Einblicke und Updates."
      },
      "docs": {
        "label": "Dokumentation und Integrationen",
        "desc": "Technische Dokumentation und API-Anleitungen."
      },
      "helpCenter": {
        "label": "Help Center",
        "desc": "Support und Dokumentation."
      },
      "diventaPartner": {
        "label": "Partner werden",
        "desc": "Treten Sie unserem Partnernetzwerk bei."
      },
      "casiUso": {
        "label": "Anwendungsfälle",
        "desc": "Lesen Sie die Erfolgsgeschichten unserer Kunden."
      },
      "ultimeNotizie": {
        "label": "Neueste Nachrichten",
        "desc": "Bleiben Sie auf dem Laufenden - abonnieren Sie den Newsletter."
      }
    }
  },
  "footer": {
    "contact": "Kontakte",
    "follow": "Folgen",
    "pages": "Seiten",
    "blog": "BLOG von Bonsai",
    "discover": "Entdecken",
    "terms": "Allgemeine Geschäftsbedingungen",
    "privacy": "Datenschutzerklärung",
    "cta": "Anruf buchen",
    "compliance": "Compliance:",
    "complianceLine1": "Bonsai arbeitet unter Einhaltung der Amazon SP-API Policies. Der Zugriff und die Nutzung von Daten sind reguliert und auf autorisierte Zwecke beschränkt.",
    "complianceLine2": "Bonsai speichert, verarbeitet oder überträgt keine Amazon-Daten außerhalb der offiziellen SP-API-Verbindungen.",
    "copyright": "© {year} Bonsai. Alle Rechte vorbehalten.",
    "sedeLegale": "Rechtssitz:",
    "sedeOperativa": "Betriebssitz:"
  },
  "common": {
    "home": "Startseite",
    "contatti": "Kontakte",
    "send": "Senden",
    "email": "E-Mail",
    "name": "Vorname",
    "surname": "Nachname",
    "phone": "Telefon",
    "notes": "Notizen"
  },
  "a11y": {
    "skipToContent": "Zum Hauptinhalt springen",
    "loading": "Wird geladen..."
  }
},
  es: {
  "nav": {
    "prezzi": "Precios",
    "moduli": "Módulos",
    "onboarding": "Onboarding",
    "integrazioni": "Integraciones",
    "supporto": "Soporte",
    "blog": "Blog",
    "cta": "Prueba Bonsai",
    "moduliAll": "Ver todos los módulos",
    "moduliAllDesc": "Panorámica y comparación de los módulos BSpanel"
  },
  "hero": {
    "badge": "Gestión de marketplaces unificada",
    "title": "Un sistema integrado para todos los canales de venta.",
    "subtitle": "Centraliza todas las actividades operativas para aumentar las ventas online.",
    "cta": "Prueba demo",
    "feat1": "Onboarding asistido en 24h",
    "feat2": "Soporte 7/7 h24",
    "topline": "",
    "dashboardOverlay": "Solicita una demo"
  },
  "proof": {
    "badge": "Resultados",
    "title": "Primeros 3 meses",
    "stat1": "Pedidos/día",
    "stat2": "Errores picking",
    "stat3": "Errores ficha producto",
    "quote": "\"Pedidos Amazon y Temu unificados. +25% en 3 meses.\"",
    "author": "Alberto, COO Baroni Home",
    "scaleTitle": "Escala sin fricciones",
    "scaleItems": [
      "+100k variantes",
      "5k envíos/día",
      "Asistencia con respuesta en 10 minutos",
      "Modular y escalable. El sistema crece con tus ventas"
    ]
  },
  "clients": {
    "title": "Han elegido Bonsai"
  },
  "whybonsai": {
    "badge": "Por eso",
    "title": "Bonsai",
    "subtitle": "Gestiona, automatiza y analiza todos los canales desde un único punto.",
    "features": {
      "automation": "Automatización Pedidos",
      "marketplace": "Marketplace",
      "analytics": "Analytics",
      "warehouse": "Almacén",
      "integration": "Integraciones",
      "operations": "Operatividad",
      "shipping": "Envíos"
    },
    "outputs": {
      "multichannel": "Multicanal"
    },
    "labels": {
      "csvExcel": "CSV/EXCEL",
      "apiCustom": "API CUSTOM",
      "wms": "WMS",
      "altri": "OTROS SISTEMAS"
    }
  },
  "modules": {
    "badge": "Módulos",
    "title": "Elige lo que necesitas",
    "subtitle": "Cada módulo es independiente. Escala cuando quieras.",
    "channelsLabel": "Canales / Integraciones",
    "featuresLabel": "Funcionalidades principales"
  },
  "comparison": {
    "badge": "Comparación",
    "title": "Todo en uno. Los demás no.",
    "subtitle": "",
    "feature": "Funcionalidad",
    "competitor": "Competidor"
  },
  "press": {
    "badge": "Hablan de nosotros"
  },
  "faq": {
    "badge": "FAQ",
    "title": "Preguntas frecuentes",
    "subtitle": "",
    "discoverAll": "Descubre todas las FAQ"
  },
  "whyModular": {
    "alwaysIncluded": "SIEMPRE INCLUIDO"
  },
  "risorse": {
    "label": "Recursos",
    "sezioni": {
      "scopri": "Descubre",
      "partner": "Partner",
      "clienti": "Clientes",
      "news": "News"
    },
    "items": {
      "blog": {
        "label": "Blog",
        "desc": "Análisis y actualizaciones."
      },
      "docs": {
        "label": "Documentación e Integraciones",
        "desc": "Documentación técnica y guías API."
      },
      "helpCenter": {
        "label": "Help Center",
        "desc": "Soporte y documentación."
      },
      "diventaPartner": {
        "label": "Hazte partner",
        "desc": "Entra en nuestra red de partners."
      },
      "casiUso": {
        "label": "Casos de uso",
        "desc": "Lee las historias de éxito de nuestros clientes."
      },
      "ultimeNotizie": {
        "label": "Últimas noticias",
        "desc": "Mantente actualizado - suscríbete al newsletter."
      }
    }
  },
  "footer": {
    "contact": "Contactos",
    "follow": "Follow",
    "pages": "Páginas",
    "blog": "BLOG Of Bonsai",
    "discover": "Descubre",
    "terms": "Términos y condiciones",
    "privacy": "Política de Privacidad",
    "cta": "Reserva una llamada",
    "compliance": "Compliance:",
    "complianceLine1": "Bonsai opera respetando las Amazon SP-API Policies. El acceso y uso de los datos está regulado y limitado a las finalidades autorizadas.",
    "complianceLine2": "Bonsai no almacena, procesa ni transmite datos de Amazon fuera de las conexiones oficiales SP-API.",
    "copyright": "© {year} Bonsai. Todos los derechos reservados.",
    "sedeLegale": "Sede Legal:",
    "sedeOperativa": "Sede Operativa:"
  },
  "common": {
    "home": "Inicio",
    "contatti": "Contactos",
    "send": "Enviar",
    "email": "Email",
    "name": "Nombre",
    "surname": "Apellido",
    "phone": "Teléfono",
    "notes": "Notas"
  },
  "a11y": {
    "skipToContent": "Ir al contenido principal",
    "loading": "Cargando..."
  }
}
};

export default translations;
